<template>
  <div class="container page">
    <van-nav-bar title="儲值記錄" class="nav-bar">
      <template #left>
        <img
          src="/img/newLogin/download.png"
          @click="back"
          style="width: 20px; height: 15px;"
        />
      </template>
    </van-nav-bar>

    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div v-if="pageLoading" class="page-loading">
          <van-loading size="28px">載入中...</van-loading>
        </div>

        <van-empty
          v-else-if="list.length === 0"
          description="暫無儲值記錄"
        />

        <template v-else>
          <div
            v-for="item in list"
            :key="item.id"
            class="item_list"
          >
            <div class="topInfo">
              <span
                class="status"
                :class="{ success: item.isAdopt || Number(item.status) === 1 }"
              >
                {{ item.status_text || getStatusText(item.status) }}
              </span>

              <span class="money">
                金額：+{{ formatMoney(item.money) }}
              </span>
            </div>

            <div v-if="getOrderNo(item)" class="desc">
              <span>訂單編號：{{ getOrderNo(item) }}</span>
            </div>

            <div v-if="item.desc" class="desc">
              <span>備註：{{ item.desc }}</span>
            </div>

            <div class="time">
              <span>提交時間：{{ item.create_time || "-" }}</span>
            </div>

            <div class="time">
              <span>審核時間：{{ item.update_time || "待審核" }}</span>
            </div>
          </div>
        </template>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      pageLoading: true,
      list: [],
    };
  },

  methods: {
    back() {
      window.history.back();
    },

    onRefresh() {
      this.getUserRechargeList(true);
    },

    normalizeList(data) {
      if (Array.isArray(data)) {
        return data;
      }

      if (data && Array.isArray(data.list)) {
        return data.list;
      }

      if (data && Array.isArray(data.data)) {
        return data.data;
      }

      return [];
    },

    getStatusText(status) {
      const value = Number(status);

      if (value === 0) return "待審核";
      if (value === 1) return "儲值成功";
      if (value === 2) return "審核失敗";
      if (value === 3) return "已忽略";

      return "處理中";
    },

    getOrderNo(item) {
      return (
        item.oid ||
        item.order_no ||
        item.order_sn ||
        item.trade_no ||
        item.sn ||
        ""
      );
    },

    formatMoney(value) {
      const money = Number(value);

      if (!Number.isFinite(money)) {
        return value || "0";
      }

      return Number.isInteger(money)
        ? String(money)
        : money.toFixed(2);
    },

    getUserRechargeList(fromRefresh = false) {
      if (!fromRefresh) {
        this.pageLoading = true;
      }

      this.$http({
        method: "get",
        url: "user_get_recharge_list",
      })
        .then((res) => {
          if (res.code === 200) {
            this.list = this.normalizeList(res.data);
          } else if (res.code === 401) {
            this.list = [];
            this.$toast(res.msg);

            if (!localStorage.getItem("token")) {
              this.$router.push({ path: "/Login" });
            }
          } else {
            this.list = [];
            this.$toast(res.msg || "儲值記錄載入失敗");
          }
        })
        .catch(() => {
          this.list = [];
          this.$toast("儲值記錄載入失敗");
        })
        .then(() => {
          this.pageLoading = false;
          this.isLoading = false;

          if (fromRefresh) {
            this.$toast("刷新成功");
          }
        });
    },
  },

  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserRechargeList(false);
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.container {
  background-color: #1f1c1f;
}

.container .main {
  position: relative;
  overflow-y: auto;
  height: 100%;
  padding: 0 10px 30px;
  box-sizing: border-box;
  background-color: #1f1c1f;
}

.page-loading {
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .page-loading .van-loading__text {
  color: #f3c7a2;
  font-size: 26px;
}

::v-deep .van-pull-refresh__head,
::v-deep .van-pull-refresh__head * {
  color: #f3c7a2;
}

::v-deep .van-empty__description {
  color: #999999;
}

.item_list {
  padding: 22px 20px;
  margin: 25px 10px;
  background: linear-gradient(120deg, #212121, #313131);
  border: 1px solid #766350;
  border-radius: 10px;
  box-shadow: 0 2px 8px #000000;
  box-sizing: border-box;
}

.topInfo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 50px;
}

.status {
  font-size: 30px;
  font-weight: 700;
  color: #f3c7a2;
}

.status.success {
  color: #07c160;
}

.money {
  font-size: 30px;
  font-weight: 700;
  color: #f3c7a2;
  text-align: right;
}

.desc {
  margin-top: 8px;
  line-height: 42px;
  word-break: break-all;
}

.desc span {
  font-size: 24px;
  font-weight: 500;
  color: #9b9b9b;
}

.time {
  margin-top: 6px;
  line-height: 42px;
}

.time span {
  font-size: 24px;
  font-weight: 500;
  color: #f3c7a2;
}
</style>